import { CarDealer } from "../src/modules/carDealer";

export { CarDealer as default };
